/* eslint-disable @typescript-eslint/no-empty-function */
import { Backdrop, CircularProgress } from '@mui/material'
import { ADMIN_URLS } from 'constans/urls'
import useLogin from 'hooks/useLogin'
import {
  PropsWithChildren,
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { AdminDetailModel, AdminLoginRequestModel } from 'types/admin'
import { ApiResponseModel } from 'types/common'
import { getWithExpiry } from 'utils/localStorage'

export interface AuthData {
  profile?: AdminDetailModel
  onSetProfile: (p?: AdminDetailModel) => void

  isAuthenticated?: boolean
  onLogin: (
    p: AdminLoginRequestModel
  ) => Promise<ApiResponseModel<AdminDetailModel | undefined> | undefined>
  isLogin: boolean
}

export const AuthContext = createContext<AuthData>({
  profile: undefined,
  onSetProfile: () => {},
  isAuthenticated: false,
  onLogin: () => Promise.resolve(undefined),
  isLogin: false,
})

const AuthProvider = (props: PropsWithChildren) => {
  const [currentPath] = useState(() => window.location.pathname)
  const { onLogin, isLogin } = useLogin()
  const [profile, setProfile] = useState<AdminDetailModel | undefined>(
    undefined
  )

  const onSetProfile = useCallback((data?: AdminDetailModel) => {
    setProfile(data)
  }, [])

  const isAuthenticated = useMemo(() => !!profile, [profile])
  const isLoginPage = window.location.pathname === ADMIN_URLS.LOGIN

  useEffect(() => {
    const fetchProfile = async (usr: string, pwd: string) => {
      const res = await onLogin({ userName: usr, password: pwd })
      if (res.ErrorCode === 0) {
        setProfile(res.Result)
        if (isLoginPage) {
          window.location.href = currentPath
        }
      } else {
        if (!isLoginPage) {
          window.location.href = ADMIN_URLS.LOGIN
        }
      }
    }
    const userName = getWithExpiry('userName')
    const password = getWithExpiry('password')

    if (!isAuthenticated && userName && password && !isLogin) {
      fetchProfile(userName, password)
    } else {
      if (!isLoginPage && !isAuthenticated && !isLogin) {
        window.location.href = ADMIN_URLS.LOGIN
      }
    }
  }, [isAuthenticated, onLogin, isLoginPage, isLogin, currentPath])

  if (!isAuthenticated && !isLoginPage) {
    return (
      <Backdrop
        open
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  return (
    <AuthContext.Provider
      value={{ profile, isAuthenticated, onSetProfile, onLogin, isLogin }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
